let BASE_API_URL = "https://staging-acuityapi.digiryte.co.uk";

if (process.env.REACT_APP_ENV === "development") {
  BASE_API_URL = "https://staging-acuityapi.digiryte.co.uk";
}

if (process.env.REACT_APP_ENV === "preproduction") {
  BASE_API_URL = "https://preprod-acuity-api.digiryte.co.uk";
}

let BASE_URL = "http://localhost:3000";

if (process.env.REACT_APP_ENV === "development") {
  BASE_URL = "https://develop.dcad0fg2xzyt3.amplifyapp.com";
}

if (process.env.REACT_APP_ENV === "preproduction") {
  BASE_URL = "https://pre-production.d24r8k8t9kswiu.amplifyapp.com";
}
export { BASE_API_URL, BASE_URL };

export const api_url = {
  login: "auth/sign_in",
  submit_registration_request: "submit_registration_request",
  password: "auth/password",
  organisation: "/organisations",
};
